module.exports = __webpack_public_path__ + "img/section2.62692180.png";